<app-form-tagbase
    [dataItem]="dataItem"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-tagbase>
